/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import DASHBOARD from './modules/userDashboard.js'
import USER_AUTH from './modules/authentication.js'
import NOTIFICATION from './modules/userNotification.js'
import PROFILE from './modules/userProfile.js'

Vue.use(Vuex, axios)

export default new Vuex.Store({
   //strict: true,
   modules: {
      DASHBOARD,
      USER_AUTH,
      NOTIFICATION,
      PROFILE
   }
})


// WEBPACK FOOTER //
// ./src/store.js